import * as React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { IDefaultUIProps } from '../..'
import { buildUrl, hasValue } from '../../util'
import ErrorBoundary from '../common/ErrorBoundary'
import WidgetsList from './Widgets'
import CreateWidget from './CreateWidget'
import '../templates/templates'
import '../common/ui-fields/uiFields'
import './DesignerComponent.scss'
import EditWidget from './EditWidget'
import ConfigComponent from './Config'

interface IDesignerComponentProps extends IDefaultUIProps {
    modelKey: string,
    initialSource: string
}

const DesignerComponent: React.FunctionComponent<IDesignerComponentProps> = (props) => {

    const { uxpContext } = props

    return <Switch>
        <Route exact path={buildUrl(uxpContext, '')} >
            <ErrorBoundary key={'/'}>
                <Redirect to={buildUrl(uxpContext, 'widgets')} />
            </ErrorBoundary>
        </Route>

        <Route exact path={buildUrl(uxpContext, 'widgets')} >
            <ErrorBoundary key={'widgets'}>
                <WidgetsList
                    uxpContext={uxpContext}
                />
            </ErrorBoundary>
        </Route>

        <Route exact path={buildUrl(uxpContext, 'widgets/new/:template')}>
            <ErrorBoundary key={'new'}>
                <CreateWidget
                    modelKey={props.modelKey}
                    initialSource={props.initialSource}
                    uxpContext={uxpContext}
                />
            </ErrorBoundary>
        </Route>

        <Route exact path={buildUrl(uxpContext, 'widgets/edit/:id')}>
            <ErrorBoundary key={'edit'}>
                <EditWidget
                    uxpContext={uxpContext}
                />
            </ErrorBoundary>
        </Route>

        <Route path={buildUrl(uxpContext, 'config')} >
            <ErrorBoundary key={'config'}>
                {/* this is just to use in dev env */}
                <ConfigComponent uxpContext={uxpContext} />
            </ErrorBoundary>
        </Route>

    </Switch>
}

export default DesignerComponent